import { render, staticRenderFns } from "./DepgermanForm.vue?vue&type=template&id=e0d74512&scoped=true&"
import script from "./DepgermanForm.vue?vue&type=script&lang=js&"
export * from "./DepgermanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d74512",
  null
  
)

export default component.exports